import { render, staticRenderFns } from "./SmplEditManuChild.vue?vue&type=template&id=1b5be6a8&scoped=true&"
import script from "./SmplEditManuChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditManuChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditManuChild.vue?vue&type=style&index=0&id=1b5be6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5be6a8",
  null
  
)

export default component.exports